import { NetworkRequestMiddleware, RequestContext } from "fw";

export class NetworkAuthMiddleware implements NetworkRequestMiddleware {
    public token: string = null;

    onRequest(context: RequestContext) {
        if (this.token != null) {
            context.addHeader("Authorization", `Bearer ${this.token}`);
        }
    }
}
